import { Avatar1, Avatar2, Avatar3, Avatar4, Avatar5, FeaturedShape } from '@/assets/images'

const avatars = [Avatar1, Avatar2, Avatar3, Avatar4, Avatar5]

// Legacy rendered the avatars twice: a spaced row on desktop and a react-slick strip on mobile.
// The mobile strip is a scrollable row here — slick is outside the allowed dependency set.
export function RecruitersSection() {
  return (
    <section className="recruiters-section">
      <div className="container">
        <h6>
          Independent professionals recruiters <span>everywhere</span>
        </h6>

        <div className="recruiters-section-main">
          {avatars.map((avatar, index) => (
            <img key={index} src={avatar} alt="" />
          ))}
        </div>

        <div className="recruiters-section-mobile">
          {avatars.map((avatar, index) => (
            <img key={index} src={avatar} alt="" />
          ))}
        </div>
      </div>

      <div className="recruiters-section-bottom">
        <img src={FeaturedShape} alt="" />
      </div>
    </section>
  )
}
